import { useEffect, useState } from "react";
import api, { mediaUrl } from "@/lib/api";
import SEO from "@/components/SEO";
import MediaImage from "@/components/MediaImage";

export default function About() {
  const [page, setPage] = useState(null);
  const [settings, setSettings] = useState({});

  useEffect(() => {
    api.get("/pages/ueber-mich").then(({ data }) => setPage(data)).catch(() => {});
    api.get("/settings").then(({ data }) => setSettings(data)).catch(() => {});
  }, []);

  return (
    <div className="on-dark violet-canvas fade-in flex-1 w-full">
      <div className="mx-auto max-w-5xl px-5 sm:px-8 py-16 sm:py-24">
      <SEO title="Über mich" description="Über die Künstlerin Susanne Monika Gysin." image={mediaUrl(settings.about_portrait)} />
      <div className="grid md:grid-cols-5 gap-10 md:gap-16">
        <div className="md:col-span-2">
          <div className="overflow-hidden bg-[#632A8E]/30 ring-1 ring-[#F4C542]/20 rounded-md md:sticky md:top-28">
            {settings.about_portrait ? (
              <img
                src={mediaUrl(settings.about_portrait)}
                alt="Susanne Monika Gysin"
                className="block w-full h-auto"
                data-testid="about-portrait"
              />
            ) : (
              <MediaImage id={null} alt="Susanne Monika Gysin" aspect="aspect-[4/5]" className="w-full" />
            )}
          </div>
        </div>
        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.25em] text-[#F4C542] mb-5">Über mich</div>
          <h1 className="font-serif text-5xl sm:text-6xl font-light leading-tight text-[#FFF9F2]">{page?.title || "Über Susanne Monika Gysin"}</h1>
          <div className="mt-8 text-lg text-[#D8B9EA] leading-relaxed whitespace-pre-wrap">
            {page?.content || "[Hier entsteht die Biografie von Susanne Monika Gysin. Dieser Text kann im Admin-Bereich bearbeitet werden.]"}
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}
